import React from 'react'

import { IQBRReportIssueAttachment } from '../../../../models'

import { Attachment } from './components/attachment/Attachment'

import styles from './AttachmentFiles.module.scss'

interface IAttachmentFiles {
  files: IQBRReportIssueAttachment[]
  onDelete: (id: string) => void
  isDisabled?: boolean
}

export const AttachmentFiles = ({ files, onDelete, isDisabled }: IAttachmentFiles) => {
  return (
    <div>
      <div className={styles.uploadedFilesContainer}>
        {files.map(({ id, fileName, link = '' }) => (
          <Attachment
            isFile
            key={fileName + id}
            link={link}
            text={fileName}
            isDisabled={isDisabled}
            onDelete={() => {
              onDelete(id)
            }}
          />
        ))}
      </div>
    </div>
  )
}
